<wbo-search-page>
    <wbo-search-grid>
        <wbo-column field="instanceId"></wbo-column>
        <wbo-column field="instanceName" [sortable]="false"></wbo-column>
        <wbo-column field="webTerminalNames" [sortable]="false"></wbo-column>
        <wbo-url-link-column field="instanceUrl" [sortable]="false"></wbo-url-link-column>
        <wbo-date-time-column field="lastLogin"></wbo-date-time-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
